import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

function StatusBreakdownChart({ data }) {
  if (!data || !data.status_breakdown) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <p className="text-slate-500 font-montserrat">No hay datos disponibles</p>
      </div>
    );
  }

  const chartData = Object.entries(data.status_breakdown).map(([status, count]) => ({
    name: status === 'entregado' ? 'Entregado' : status === 'rechazado' ? 'Rechazado' : status === 'cancelado' ? 'Cancelado' : status,
    value: count
  }));

  const COLORS = {
    'Entregado': '#67A43C',
    'Rechazado': '#ef4444',
    'Cancelado': '#64748b'
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Chart */}
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[entry.name] || '#94a3b8'} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Stats Summary */}
        <div className="flex flex-col justify-center space-y-4">
          <div className="bg-gradient-to-r from-[#67A43C]/10 to-[#67A43C]/5 rounded-lg p-4 border-l-4 border-[#67A43C]">
            <p className="text-sm text-slate-600 font-montserrat mb-1">Tasa de Éxito</p>
            <p className="text-3xl font-bold text-[#67A43C] font-montserrat">
              {data.success_rate}%
            </p>
          </div>
          
          <div className="bg-slate-50 rounded-lg p-4">
            <p className="text-sm text-slate-600 font-montserrat mb-1">Total de Entregas</p>
            <p className="text-3xl font-bold text-slate-900 font-montserrat">
              {data.total_deliveries}
            </p>
          </div>

          <div className="bg-slate-50 rounded-lg p-4">
            <p className="text-sm text-slate-600 font-montserrat mb-1">Total de Paquetes</p>
            <p className="text-3xl font-bold text-slate-900 font-montserrat">
              {data.total_packages}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatusBreakdownChart;